import React, { useContext } from "react";
import { Card, Layout, Caption, Collapsible, TextContainer, TextStyle } from "@shopify/polaris";
import { DropZone } from "lib/components";

// import constant
import constant from "lib/constant/constant";
import { baseHelper } from "lib/helpers";

// import context
import { PrivateContext } from "lib/context";
import { BrandingContext } from "app/setup/modules/operator/features/branding/context/context";

const Cover = () => {
  const { IMAGE_URL } = constant;
  const {
    coverImageURL: imageUrl,
    handleChange,
    // learnMore
  } = useContext(BrandingContext);
  const { cms = () => {}, currentUser } = useContext(PrivateContext);
  const { brand } = currentUser || {};
  const { updatedAt = "" } = brand || {};

  return (
    <Collapsible open>
      <Layout.AnnotatedSection title={cms("section.cover.title")} description={cms("section.cover.description")}>
        <Card
          title={[
            cms("section.cover.title"),
            updatedAt && (
              <TextStyle variation="subdued">
                <Caption>{`${baseHelper.lastUpdateDate(updatedAt)}`}</Caption>
              </TextStyle>
            ),
          ]}
          // actions={[{ content: "Learn more", onAction: () => learnMore("Updated your brand cover", "TODO: ") }]}
        >
          <Card.Section>
            <TextContainer>
              {cms("section.cover.subDescription")}
              <small>(recommended size 2000px X 400px)</small>
            </TextContainer>
            <br />
            <DropZone
              id="dropZone"
              onAdd={(value) => handleChange(IMAGE_URL, (value && value.length && value[0]) || "", IMAGE_URL)}
              onRemove={() => handleChange(IMAGE_URL, "", IMAGE_URL)}
              fileList={(imageUrl !== "" && [imageUrl]) || []}
              allowMultiple={false}
            />
            <br />
            <Caption>{cms("section.cover.value.defaultText")}</Caption>
          </Card.Section>
        </Card>
      </Layout.AnnotatedSection>
    </Collapsible>
  );
};

export default Cover;
